import React from "react";
import parse, { domToReact } from "html-react-parser";
import { ArrowRightCircleIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

// Fonction de parsing personnalisée pour remplacer les li par des icônes
const parseWithIcons = (htmlContent, type = "arrow") => {
  if (!htmlContent || typeof htmlContent !== "string") {
    return null;
  }

  const options = {
    replace: (domNode) => {
      if (domNode.name === "li") {
        return (
          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "16px",
            }}
          >
            {type === "arrow" && (
              <ArrowRightCircleIcon
                style={{
                  width: "20px",
                  height: "20px",
                  color: "var(--color-golden-500)",
                  marginRight: "8px",
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
            )}
            {type === "check" && (
              <CheckCircleIcon
                style={{
                  width: "20px",
                  height: "20px",
                  color: "var(--color-golden-500)",
                  marginRight: "8px",
                  marginTop: "3px",
                  flexShrink: 0,
                }}
              />
            )}
            <span>{domToReact(domNode.children, options)}</span>
          </li>
        );
      }
    },
  };

  return parse(htmlContent, options);
};

export default parseWithIcons;
